import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Box, TextField, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import useApi from "utils/useApi"; // Assuming you have a utility for API calls
import AlertMessage from "components/forms/AlertMessage"; // Assuming you have a component for displaying messages
import resetPasswordSchema from "formValidationSchemas/resetPasswordSchema";
import AppTheme from "components/forms/AppTheme";
import PasswordFormField from "components/forms/PasswordFormField";
import { content } from "constants/content";
import { Button } from "techhype-components";

const ResetPasswordForm = ({ lang }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(resetPasswordSchema),
  });
  const [statusMessage, setStatusMessage] = useState(null);
  const { token } = useParams(); // Get the token from the URL
  const navigate = useNavigate();
  const { post } = useApi();

  const onSubmit = async (data) => {
    try {
      const response = await post(`/auth/resetpassword/${token}`, data);
      console.log("response:", response); // For debugging

  
      if (response.status === "success") {
        setStatusMessage({
          type: "success",
          text: response.data.message || "Password reset was successful. You can now log in with your new password.",
        });
        setTimeout(() => navigate("/login"), 3000); // Redirect after success
      } else {
        let errorMessage = response.data.message || "An error occurred while resetting your password. Please try again.";
  
        if (response.data.statusCode === 400 && response.data.message) {
          if (response.data.message.includes("Invalid or expired password reset link")) {
            errorMessage = "The password reset link is invalid or has expired. Please request a new one.";
          }
        }
  
        setStatusMessage({
          type: "error",
          text: errorMessage,
        });
      }
    } catch (error) {
      console.error("Error during password reset:", error);
      setStatusMessage({
        type: "error",
        text: "Failed to reset the password. Please try again later.",
      });
    }
  };
  
  

  return (
    <Box p={4} maxWidth="500px" margin="0 auto">
      <Typography variant="h4" mb={3}>
        {content[lang]["resetTitle"]}
      </Typography>
      <form
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        style={{
          display: "flex",
          gap: "1.5em",
          flexDirection: "column",
          borderRadius: "10px",
          marginBottom: "1em",
        }}
      >
        <AppTheme>
          <PasswordFormField control={control} errors={errors} lang={lang} />
        </AppTheme>
        <Button variant="contained" color="primary" type="submit">
          {content[lang]["resetButton"]}
        </Button>
      </form>
      {statusMessage && (
        <AlertMessage
          variant={statusMessage.type === "success" ? "success" : "warning"}
          title={statusMessage.type === "success" ? "Success" : "Error"}
          message={statusMessage.text}
        />
      )}
    </Box>
  );
};

export default ResetPasswordForm;
